import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface MembersToolbarActionProps {
  onClick: () => void
  isDisabled: boolean
}

export const MembersToolbarAction: React.FC<MembersToolbarActionProps> = ({
  onClick,
  isDisabled,
}): ReactNode => (
  <Button size="sm" onClick={onClick} disabled={isDisabled} className="invite-member-button">
    <PlusIcon className="mr-2 size-4" />
    Invite Member
  </Button>
)

MembersToolbarAction.displayName = 'MembersToolbarAction'
